/** Keep aligned with `src/utils/syntheticSku.ts`. */

export function isSyntheticSlugSku(sku?: string, sourceUrl?: string, skuSource?: string): boolean {
  if (skuSource === 'handle') return true;
  if (skuSource === 'vendor') return false;
  const s = (sku || '').trim().toLowerCase();
  if (!s || !sourceUrl) return false;
  const handle = sourceUrl.toLowerCase().split('/products/').pop()?.split(/[?#]/)[0] || '';
  return handle.length > 0 && handle === s;
}
